import React from 'react';
import ReactDOM from 'react-dom/client';

import HeaderMenu from './components/headerMenu/HeaderMenu';
//import reportWebVitals from './reportWebVitals';

import Editor from './components/editor/Editor';
import Timeline from './components/timeline/Timeline';
import Gallery, { GalleryImage } from './components/gallery/Gallery';
import Parallax, { ParallaxData } from './components/parallax/Parallax';

const initLegacyDomBindings = (): void => {
  const nav = document.querySelector('header nav#nav-main');
  const navMenuWrapper = document.querySelector('header div.menu-great');
  const smallMenuButton = document.querySelector('a#small-menu-button');
  let isOverMenu = false;
  let hoverTimer: number | null = null;
  
  const isMobileMenuOpen = (): boolean => {
    return document.querySelector('header div.menu-great')?.classList.contains('mobileshow') ?? false;
  };

  const closeFirstLevelMenus = (): void => {
    nav?.querySelectorAll('.fstlvl.show').forEach((menu) => {
      menu.classList.remove('show');
    });
  };

  document
    .querySelectorAll<HTMLAnchorElement>('header nav#nav-main > ul > li > a')
    .forEach((anchor) => {
      if (anchor.classList.contains('ws-arrow-up')) {
        return;
      }

      anchor.addEventListener('mouseover', () => {
        isOverMenu = true;
        if (isMobileMenuOpen()) {
          return;
        }

        const parentLi = anchor.closest('li');
        const firstLevelMenu = parentLi?.querySelector<HTMLElement>('.fstlvl') ?? null;

        if (!firstLevelMenu?.classList.contains('show')) {
          closeFirstLevelMenus();
        }

        if (hoverTimer !== null) {
          window.clearTimeout(hoverTimer);
        }

        hoverTimer = window.setTimeout(() => {
          if (isOverMenu) {
            firstLevelMenu?.classList.add('show');
          }
        }, 200);
      });
    });

  document.querySelectorAll('main').forEach((target) => {
    target.addEventListener('mouseover', () => {
      if (!isMobileMenuOpen()) {
        closeFirstLevelMenus();
        isOverMenu = false;
      }
    });
  });

  smallMenuButton?.addEventListener('click', (event) => {
    event.preventDefault();
    // Live-Query um veraltete Referenz nach React-Re-Render zu vermeiden
    const liveMenuWrapper = document.querySelector('header div.menu-great');
    liveMenuWrapper?.classList.toggle('mobileshow');
  });

  document.body.addEventListener('click', (event) => {
    const target = event.target as HTMLElement | null;
    if (!target || !isMobileMenuOpen()) {
      return;
    }

    const clickInsideMenuBody = !!target.closest('.main-menu-body');
    const clickOnMenuButton = !!target.closest('#small-menu-button');
    if (!clickInsideMenuBody && !clickOnMenuButton) {
      document.querySelector('header div.menu-great')?.classList.remove('mobileshow');
    }
  });

  document.querySelectorAll<HTMLSelectElement>('select.mobile_page_selector').forEach((selector) => {
    selector.addEventListener('change', () => {
      const selectedOption = selector.selectedOptions[0];
      const href = selectedOption?.getAttribute('data-href');
      if (href) {
        window.location.href = href;
      }
    });
  });

  document.querySelectorAll<HTMLImageElement>('img.preview').forEach((img) => {
    img.closest('a')?.classList.add('a_noeffekt');
  });

  document.getElementById('submit')?.addEventListener('click', () => {
    document.getElementById('email')?.removeAttribute('required');
  });

  document.querySelectorAll<HTMLAnchorElement>('a.no_href').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      event.preventDefault();
    });
  });
};

const mainMenuDom = document.querySelector("header div[role='mainmenu'][data-mode='hasEditor']") as HTMLElement;
const mainEditorDom = document.querySelector("main[role='main']") as HTMLElement;

// Initialize legacy DOM bindings FIRST, before React renders anything
initLegacyDomBindings();

//Main menu will be rendered in header with role "mainmenu"
if(mainMenuDom){ 
  //Appending editor component to main content
  const editorDom = document.createElement("div");
        mainMenuDom.appendChild(editorDom);

  const menuEditorDom = ReactDOM.createRoot(
    editorDom
  );

  menuEditorDom?.render(
    <React.StrictMode>
      <HeaderMenu />
    </React.StrictMode>
  );
}

  if(mainEditorDom){ 
    if(mainEditorDom.querySelector("[data-mode='editor']")){
      const editorBodyDom = mainEditorDom.querySelector("[data-mode='editor']") as HTMLElement;
      const body = ReactDOM.createRoot(
        editorBodyDom
      );
        
      body?.render(
        <React.StrictMode>
          <Editor 
            showEdiorButton={ false }
            openEdior={ true }
          />
        </React.StrictMode>
      );
    }
    else {
      const editorbuttonDom = mainEditorDom.querySelector("[role='editorbutton']") as HTMLElement;

      if(mainEditorDom.getAttribute("data-mode") === "hasEditor" && editorbuttonDom){    
        //Appending editor component to main content
        const editorDom = document.createElement("div");
        editorbuttonDom.appendChild(editorDom);

        const editor = ReactDOM.createRoot(
          editorDom
        );

        editor?.render(
          <React.StrictMode>
            <Editor 
              showEdiorButton={ true }
            />
          </React.StrictMode>
        );
      }
    }
  }

// Timeline Loader - Functional approach with container refs
const loadTimelines = (): void => {
  const timelineElements = document.querySelectorAll('[role="timeline"]');
  timelineElements.forEach((element: Element) => {
    try {
      const timelineElement = element as HTMLElement;
      const dataAttr = timelineElement.getAttribute('data-timeline');
      if (!dataAttr) return;

      const timelineData = JSON.parse(dataAttr);
      const containerRef : React.RefObject<HTMLElement | null> = React.createRef<HTMLElement>();
      // Set the ref immediately since the element already exists
      (containerRef as any).current = timelineElement;

      const root = ReactDOM.createRoot(timelineElement);

      root.render(
        <React.StrictMode>
          <Timeline data={timelineData} containerRef={containerRef} />
        </React.StrictMode>
      );
    } catch (error) {
      console.error('Failed to render timeline:', error);
    }
  });
};

// Timeline Search Connector - Functional approach
const connectTimelineSearch = (): void => {
  const externalSearchInput = document.querySelector('input[data-timeline-search]') as HTMLInputElement | null;
  const timelineContainers = document.querySelectorAll('[role="timeline"]');

  if (!externalSearchInput || timelineContainers.length === 0) {
    return;
  }

  externalSearchInput.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key !== 'Enter') return;

    const searchTerm = (externalSearchInput.value || '').toLowerCase().trim();
    if (!searchTerm) return;

    // Dispatch custom event to timeline components
    timelineContainers.forEach((container: Element) => {
      const customEvent = new CustomEvent('timeline-search', {
        detail: { searchTerm },
      });
      container.dispatchEvent(customEvent);
    });
  });
};

// Initialize Timeline Loader
loadTimelines();

// Initialize Timeline Search Connector
connectTimelineSearch();

// Initialize Gallery components
const loadGalleries = (): void => {
  const galleryElements = document.querySelectorAll('[role="gallery"]');
  galleryElements.forEach((element: Element) => {
    try {
      const galleryElement = element as HTMLElement;
      const dataAttr = galleryElement.getAttribute('data-gallery');
      if (!dataAttr) return;

      const images: GalleryImage[] = JSON.parse(dataAttr);
      if (!Array.isArray(images) || images.length === 0) return;

      const showCaptions = galleryElement.getAttribute('data-show-captions') === 'true';

      const root = ReactDOM.createRoot(galleryElement);
      root.render(
        <React.StrictMode>
          <Gallery images={images} showCaptions={showCaptions} />
        </React.StrictMode>
      );
    } catch (error) {
      console.error('Failed to render gallery:', error);
    }
  });
};

// Initialize Parallax components
const loadParallax = (): void => {
  const parallaxElements = document.querySelectorAll('[role="parallax"]');
  parallaxElements.forEach((element: Element) => {
    try {
      const el = element as HTMLElement;
      const dataAttr = el.getAttribute('data-parallax-json');
      if (!dataAttr) return;

      const data: ParallaxData = JSON.parse(dataAttr);
      if (!data.imageSrc) return;

      const root = ReactDOM.createRoot(el);
      root.render(
        <React.StrictMode>
          <Parallax
            imageSrc={data.imageSrc}
            naturalWidth={data.naturalWidth}
            naturalHeight={data.naturalHeight}
            speed={data.speed ?? 0.2}
            bleed={data.bleed ?? 10}
          />
        </React.StrictMode>
      );
    } catch (error) {
      console.error('Failed to render parallax:', error);
    }
  });
};

loadParallax();
loadGalleries();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
